import { useCallback, useEffect, useMemo, useState } from "react";

import {
  Badge,
  Box,
  Button,
  Flex,
  HStack,
  InputGroup,
  Text,
} from "@chakra-ui/react";

import { propertiesColumn } from "views/admin/properties/variables";
import useApi from "hooks/useApi";
import { PROPERTIES_LISTING_API } from "constants/endpoints";
import { HttpStatusCode } from "axios";

import {
  COMMERCIAL_PROPERTY_TYPE,
  TRANSACTION_TYPE_DATA,
  PROPERTY_STATUS,
  AD_TYPE_DATA,
  SELL_RESIDENTIAL_PROPERTY_TYPE,
  SORT_TYPES,
  SORT_DIRECTIONS,
  SELL_OR_RENT_TRANSACTION_TYPE_DATA,
  // COMMERCIAL_PROPERTY_TYPE,
} from "constants/filterDropdownData";
import Pagination from "components/pagination/Pagination";

import ErrorDisplay from "components/errorDisplay/ErrorDisplay";
import { SearchBar } from "components/navbar/searchBar/SearchBar";

import { showToast } from "components/toast/Toast";
import { UPDATE_USER_AND_PROPERTY_API, UPDATE_USER_COMMENT, CLAIM_AD_FOR_OWNER_API_FN } from "constants/endpoints";
import { OverlayLoaderComponent } from "components/loader/Loader";

import SidebarFilter from "components/sidebarFilter/SidebarFilter";
import { getFilterFromLocalStorage } from "utils/common";
import { ENTITY_FILTER_TYPES } from "utils/common";
import { setFilterToLocalStorage } from "utils/common";

import ManageColumns from "components/manageColumns/ManageColumns";
import NoDataFound from "components/noDataFound/NoDataFound";
import { getOneMonthFromToday } from "utils/common";
import { areAllStatusesSame } from "utils/common";

import { transactionType as defaultTransactionType } from "constants/defaultState";
import { ENTITY_COLUMNS_TYPES } from "utils/common";

import { FiChevronsDown, FiFilter } from "react-icons/fi";

import { formatDateToDDMMYYYY } from "utils/common";
import CustomTable from "components/table/CustomTable";
import { formatAdsTableData } from "utils/common";

import Menu from "components/menu/MainMenu";
import MultiSelectMenu from "components/menu/MultiSelectMenu";
import { useHistory, useLocation } from "react-router-dom";
import { getTopCities } from "utils/common";
import ExpiryUpdateModal from "./modal/ExpiryUpdateModal";
import UpdateExpiryForAll from "./modal/UpdateExpiryForAll";
import { POST_TO_SOCIAL_MEDIA } from "constants/endpoints";
import PropertiesModal from "components/modal/PropertiesModal";
import { getPostMessage } from "utils/getPostMessage";
import RejectPropertyModal from "./modal/RejectPropertyModal";
import NearbyLeadsModal from "./modal/NearbyLeadsModal";
import { VisibilityExpiredOptions } from "constants/filterDropdownData";
import ShareToWhatsapp from "../users/components/modal/ShareToWhatsapp";
import { SWITCH_PROPERTY_LEAD_AUTOMATION } from "constants/endpoints";
import { ENABLE_LEAD_AUTOMATION_OPTIONS } from "constants/filterDropdownData";

const PAGE_SIZE = 50;
const today = new Date();
const thirtyDaysAgo = new Date();
thirtyDaysAgo.setDate(today.getDate() - 30);

const QUERY_PROPERTY_STATUS = "property_status";

const sortableColumns = ["listing_score", "created_at", "expires_on"];

export default function Properties() {
  const { apiCall, loading = true, error } = useApi();
  const [isWhatsappModalOpen, setIsWhatsappModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const [isOpenFilterSidebar, setIsOpenFilterSidebar] = useState(false);
  const history = useHistory();
  const [cityOptions, setCityOptions] = useState([]);
  const [openExpiryUpdateModal, setOpenExpiryUpdateModal] = useState(false);
  const [openALLExpiryUpdateModal, setAllOpenExpiryUpdateModal] =
    useState(false);
  const [selctedProperty, setSelctedProperty] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isExpiryModalOpen, setIsExpiryModalOpen] = useState(false);
  const [isNearbyLeadsModalOpen, setIsNearbyLeadsModalOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "",
    desc: "",
    withListingScore: false,
  });

  const [sortConfig, setSortConfig] = useState({
    sortType: "created_at",
    sortDirection: "descending",
  });

  const lsFilters = getFilterFromLocalStorage(ENTITY_FILTER_TYPES.ADS_FILTER);
  const lsFiltersAdsPageSize = getFilterFromLocalStorage(
    ENTITY_FILTER_TYPES.ADS_PAGE_SIZE
  );

  const [pageSize, setPageSize] = useState(
    lsFiltersAdsPageSize ? lsFiltersAdsPageSize : PAGE_SIZE
  );

  const { search } = useLocation();

  const queryObject = Object.fromEntries(new URLSearchParams(search));

  const [searchText, setSearchText] = useState("");

  const [filters, setFilters] = useState(() => {
    const defaultFilters = {
      adType: "",
      transactionType: "",
      propertyType: "",
      propertyStatus: "",
      sortType: "created_at",
      sortDirection: "descending",
      city: "",
      startDate: thirtyDaysAgo,
      endDate: today,
      enable_lead_automation: "",
    };

    const queryFilters = queryObject[QUERY_PROPERTY_STATUS]
      ? { propertyStatus: queryObject[QUERY_PROPERTY_STATUS] }
      : {};

    return {
      ...defaultFilters,
      ...lsFilters,
      ...queryFilters,
    };
  });

  const {
    adType = "",
    transactionType = "",
    propertyType = "",
    propertyStatus = "",
    sortType = "",
    sortDirection = "",
    visibilityExpired = "",
    enable_lead_automation = "",
  } = filters || {};

  const [filteredData, setFilteredData] = useState(
    lsFilters ? Object.keys(lsFilters).filter((item) => filters[item]) : []
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(10);
  const [propertiesData, setPropertiesData] = useState([]);
  const [filterRemoveFlagCount, setFilterRemoveFlagCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const fetchPropertiesData = useCallback(
    async (text) => {
      let body = {
        ad_type: adType,
        collection_type: transactionType,
        property_type: propertyType,
        property_status: propertyStatus ? propertyStatus : "",
        sort_by:
          sortConfig?.sort_by === "listing_score"
            ? "total_listing_score"
            : sortConfig?.sort_by || "",
        sort_order: sortConfig?.sort_order || "",
        page: currentPage,
        limit: pageSize,
        search_text: text?.trim() || searchText?.trim(),
        start_date: formatDateToDDMMYYYY(filters?.startDate),
        end_date: formatDateToDDMMYYYY(filters?.endDate),
        city: filters?.city,
        visibilityExpired,
        enable_lead_automation,
      };
      if (queryObject?.search_text) {
        body = {
          search_text: queryObject?.search_text?.trim(),
          limit: pageSize,
          page: currentPage,
        };
      }
      try {
        const res = await apiCall.get(`${PROPERTIES_LISTING_API}`, body);
        if (res?.statusCode === HttpStatusCode.Ok) {
          setPropertiesData(res?.data?.data);
          setTotalPages(Math.ceil(res?.data?.count / pageSize));
          setTotalCount(res?.data?.count);
        }
      } catch (error) {
        console.log("Error while fetching properties: ", error.message);
      }
    },
    [
      visibilityExpired,
      searchText,
      currentPage,
      adType,
      transactionType,
      propertyStatus,
      propertyType,
      sortType,
      sortDirection,
      pageSize,
      sortConfig,
      filters,
      enable_lead_automation,
    ]
  );

  useEffect(() => {
    const fetchCities = async () => {
      const topCities = await getTopCities();
      setCityOptions(topCities || []);
    };
    fetchCities();
  }, []);

  const handleFetchSearch = useCallback(
    (text) => {
      fetchPropertiesData(text);
    },
    [fetchPropertiesData]
  );

  const toggleSidebar = () => {
    setIsOpenFilterSidebar(!isOpenFilterSidebar);
  };

  useEffect(() => {
    if (queryObject?.search_text) {
      setSearchText(queryObject?.search_text);
      handleFetchSearch(queryObject?.search_text);
    } else {
      fetchPropertiesData();
      setFilterToLocalStorage(ENTITY_FILTER_TYPES.ADS_FILTER, filters);
    }
  }, [
    filterRemoveFlagCount,
    queryObject?.search_text,
    pageSize,
    currentPage,
    sortConfig,
  ]);

  const handleFilterChange = useCallback((key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
    setCurrentPage(1);
  }, []);

  const handleApplyFilter = () => {
    const applyFilterArray = filters
      ? Object.keys(filters).filter((key) => filters[key])
      : [];

    setFilteredData(applyFilterArray);
    setFilterToLocalStorage(ENTITY_FILTER_TYPES.ADS_FILTER, filters);
    setCurrentPage(1);

    setSelectedRowsData([]);
    fetchPropertiesData();
  };

  const handleRemoveAllFilter = () => {
    setFilteredData([]);

    setFilters({
      adType: "",
      transactionType: "",
      propertyType: "",

      propertyStatus: "",
      city: "",
      startDate: "",
      endDate: "",
      enable_lead_automation: "",
    });
  };

  const handleUpdatePropertyStatus = async ({
    updatedPropertyType,
    slug,
    custom_listing_score,
    shareToSocialMedia,
    message,
    status,
    comment,
  }) => {
    try {
      if (updatedPropertyType === "Update Expiry") {
        setOpenExpiryUpdateModal(true);
        return;
      }
      const data = propertiesData.find((item) => item.slug_url === slug);
      if (status === "Add Comment") {
        if (comment === data?.comment) return;
        await apiCall.post(UPDATE_USER_COMMENT, {
          user_id: data?.owner?._id,
          comment,
        });
        showToast({
          message: "Comment added successfully",
          customStyle: { background: "green", color: "#fff", padding: "10px" },
        });
        return fetchPropertiesData();
      }
      if (updatedPropertyType === "Share To Social Media") {
        const res = await apiCall
          .post(POST_TO_SOCIAL_MEDIA, {
            slug_url: slug,
            message,
          })
          .catch((error) => {
            showToast({
              message: error?.message || "Social media Posting Failed",
              success: false,
              customStyle: {
                background: "#ff0000",
                color: "#fff",
                padding: "10px",
              },
            });
          });
        const facebookPostLink = `https://www.facebook.com/hexahome.in/posts/${res?.data?.fbPostId}`;
        console.log(facebookPostLink);
        showToast({
          message: `Property posted to Social Media`,
          success: true,
          customStyle: {
            background: "#52c41a",
            color: "#fff",
            padding: "10px",
          },
        });
        return;
      }

      const {
        _id: id,
        collection_type,
        property_status,
        enable_lead_automation,
      } = data;
      if (updatedPropertyType === "Change Lead Automation") {
        const payload = {
          ad_id: id,
          ad_type: collection_type,
          enable_lead_automation: !enable_lead_automation,
        };
        await apiCall.patch(SWITCH_PROPERTY_LEAD_AUTOMATION, payload);
      } else {
        const updateData = [
          {
            type: collection_type,
            _id: id,
            property_status: updatedPropertyType || "",
            expires_on:
              property_status === "expired" ? getOneMonthFromToday() : "",
          },
        ];
        if (
          custom_listing_score !== undefined &&
          custom_listing_score !== null
        ) {
          updateData[0].custom_listing_score = custom_listing_score;
        }
        await apiCall.patch(UPDATE_USER_AND_PROPERTY_API, { updateData });
      }
      setFilterRemoveFlagCount((prev) => prev + 1);
      showToast({
        message: "Property status updated successfully",
        customStyle: {
          background: "green",
          color: "#fff",
          padding: "10px",
        },
      });

      if (shareToSocialMedia) {
        await apiCall.post(POST_TO_SOCIAL_MEDIA, {
          slug_url: slug,
          message,
        });
        showToast({
          message: "Property posted to Social Media",
          success: true,
          customStyle: {
            background: "#52c41a",
            color: "#fff",
            padding: "10px",
          },
        });
        return;
      }
    } catch (error) {
      console.log(error);
      showToast({
        message: error?.message || "Posting Failed",
        success: false,
        customStyle: {
          background: "#ff0000",
          color: "#fff",
          padding: "10px",
        },
      });
    }
  };

  const dropdownFilters = [
    {
      name: "propertyStatus",
      placeholder: "Select Status",
      value: filters?.propertyStatus,
      data: PROPERTY_STATUS,
    },
    {
      name: "adType",
      placeholder: "Select Ad Type",
      value: filters?.adType,
      data: AD_TYPE_DATA,
    },
    {
      name: "visibilityExpired",
      placeholder: "Select Visibility Expired",
      value: filters?.visibilityExpired,
      data: VisibilityExpiredOptions,
    },
    {
      name: "transactionType",
      placeholder: "Select Transaction Type",
      value: filters?.transactionType,
      data:
        filters.adType === "rent" || filters.adType === "sell"
          ? SELL_OR_RENT_TRANSACTION_TYPE_DATA
          : TRANSACTION_TYPE_DATA,
    },

    {
      name: "propertyType",
      placeholder: "Select Property Type",
      value: filters.propertyType,

      data:
        filters?.transactionType === defaultTransactionType.Residential
          ? SELL_RESIDENTIAL_PROPERTY_TYPE
          : COMMERCIAL_PROPERTY_TYPE,
      isDisabled: !(
        filters?.transactionType === defaultTransactionType.Residential ||
        filters?.transactionType === defaultTransactionType.Commercial
      ),
    },
    {
      name: "enable_lead_automation",
      data: ENABLE_LEAD_AUTOMATION_OPTIONS,
      placeholder: "Lead Automation Status",
      value: enable_lead_automation,
    },
  ];

  const dropdownSorts = [
    {
      name: "sortType",
      placeholder: "",
      value: sortType,
      data: SORT_TYPES,
    },
    {
      name: "sortDirection",
      placeholder: "",
      value: sortDirection,
      data: SORT_DIRECTIONS,
    },
  ];

  const allFiltersProps = {
    dropdowns: dropdownFilters,
    sorts: dropdownSorts,
  };

  const columns = useMemo(() => propertiesColumn, [propertiesColumn]);
  const data = useMemo(
    () => formatAdsTableData(propertiesData),
    [propertiesData]
  );

  const lsLocalStorageManageColumns = getFilterFromLocalStorage(
    ENTITY_COLUMNS_TYPES.ADS_COLUMNS
  );

  const excludedColumnVisiblity = [
    "sid",
    "meta_title",
    "meta_description",
    "owner_email",
    "collection_type"
  ];

  const [columnVisibility, setColumnVisibility] = useState(
    lsLocalStorageManageColumns
      ? lsLocalStorageManageColumns
      : columns.reduce((acc, column) => {
          acc[column.accessor] = !excludedColumnVisiblity.includes(
            column.accessor
          );

          return acc;
        }, {})
  );

  const [manageColumnSelectḀ̥̥̥̥̥̥̥̥llCheckbox, setManageColumnSelectAllCheckbox] =
    useState(false);

  const handleColumnChange = (accessor) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [accessor]: !prev[accessor],
    }));
  };

  useEffect(() => {
    setFilterToLocalStorage(ENTITY_COLUMNS_TYPES.ADS_COLUMNS, columnVisibility);
  }, [columnVisibility]);

  const visibleColumns = columns.filter(
    (column) => columnVisibility[column.accessor]
  );

  const handleInputFormSubmit = (e) => {
    e.preventDefault();

    setCurrentPage(1);
    fetchPropertiesData(searchText);
  };

  const filterBySlugUrl = (smallArray, fullArray) => {
    return fullArray.filter((fullItem) =>
      smallArray.some((smallItem) => smallItem.slug_url === fullItem.slug_url)
    );
  };

  const handleMultipleUpdateStatus = async ({
    updatedStatus,
    selectedStatus,
  }) => {
    console.log("calling===========>", updatedStatus, selectedStatus);
    const statusArray = selectedRowsData?.map((item) => item?.property_status);
    if (selectedStatus === "Update Expiry") {
      setOpenExpiryUpdateModal(true);
      return;
    }
    if (!areAllStatusesSame(statusArray)) {
      showToast({
        message: "All selected properties must have the same status",
        customStyle: {
          background: "#ff4d4f",
          color: "#fff",
          padding: "10px",
        },
      });
      return;
    }

    const filterdToBeUpdatedData = filterBySlugUrl(
      selectedRowsData,
      propertiesData
    );

    const updatedData = filterdToBeUpdatedData.map((item) => {
      return {
        type: item.collection_type,
        _id: item._id,

        property_status: updatedStatus,

        expires_on: statusArray[0] === "Expired" ? getOneMonthFromToday() : "",
      };
    });

    try {
      await apiCall.patch(UPDATE_USER_AND_PROPERTY_API, {
        updateData: updatedData,
      });

      setFilterRemoveFlagCount((prev) => prev + 1);

      showToast({
        message: "Property status updated successfully",
        customStyle: {
          background: "green",
          color: "#fff",
          padding: "10px",
        },
      });

      setSelectedRowsData([]);
    } catch (error) {}
  };

  // SELECT ROW LOGIC
  const handleRowSelect = useCallback(
    (row) => {
      const findData = selectedRowsData.find(
        (item) => item.slug_url === row.slug_url
      );

      setSelectedRowsData((prev) => {
        if (findData) {
          return prev.filter((item) => item.slug_url !== findData.slug_url);
        } else {
          return [...prev, row];
        }
      });
    },
    [setSelectedRowsData, selectedRowsData]
  );

  const selectedRowsSlug = selectedRowsData.map((item) => item.slug_url);

  const mappedRowsData = selectedRowsData.map((item) => {
    const data = propertiesData.find((row) => row._id === item._id);
    if (!data) return {};
    return {
      _id: data._id,
      collection_type: data.collection_type,
      propertyStatus: data.property_status,
      slug_url: data.slug_url,
      expires_on: data.expires_on,
    };
  });

  const selectedData = useMemo(
    () =>
      selectedRowsSlug.map((slug) => data.find((row) => row.slug_url === slug)),
    [selectedRowsSlug, data]
  );

  const setSelectedCity = (text) => {
    setFilters((prev) => {
      return { ...prev, city: text };
    });
  };

  const setStartDate = (text) => {
    setFilters((prev) => {
      return { ...prev, startDate: text };
    });
  };

  const setEndDate = (text) => {
    setFilters((prev) => {
      return { ...prev, endDate: text };
    });
  };

  const handleModalOpen = useCallback(
    (type, id, selected) => {
      if (type === "Rejected") {
        return setIsExpiryModalOpen(true);
      }
      const currentData = propertiesData.find((item) => item._id === id);
      setSelctedProperty(currentData);
      if (type === "Update Expiry") {
        setOpenExpiryUpdateModal(true);
        return;
      }
      if (type === "Change Lead Automation") {
        setModalConfig({
          title: "Change Lead Automation",
          desc: `Currently, lead automation is <span style="font-weight: bold;">${
            currentData.enable_lead_automation ? "Enabled" : "Disabled"
          }</span>. Do you want to <span style="font-weight: bold;">${
            currentData.enable_lead_automation ? "Disable" : "Enable"
          }</span> it?`,
          showPostInput: false,
          onModalSubmit: (data) => {
            setIsModalOpen(false);
            handleUpdatePropertyStatus({
              updatedPropertyType: type,
              slug: currentData.slug_url,
            });
          },
        });
        setIsModalOpen(true);
        return;
      }

      const updatedPropertyType =
        PROPERTY_STATUS.find((item) => item.label === type)?.value ?? null;

      const listingScore =
        currentData?.custom_listing_score ?? currentData?.total_listing_score;
      const postMessage = getPostMessage(currentData);
      if (type === "Show Nearby Leads") {
        setIsNearbyLeadsModalOpen(true);
        return;
      }

      if (type === "Expired Notification") {
        setIsWhatsappModalOpen(true);
        return;
      }

      if (type === "Edit") {
        const { _id, collection_type, sharing_type, property_type } =
          currentData || {};
        history.push(
          `/admin/form?id=${_id}&type=${collection_type}&property_type=${
            sharing_type || property_type
          }`
        );
        return;
      }
      if (type === "Claim For Owner") {
        (async () => {
          try {
            const { _id, collection_type } = currentData || {};
            await apiCall.patch(CLAIM_AD_FOR_OWNER_API_FN(collection_type, _id), {});
            showToast({
              message: "Ad claimed for owner",
              customStyle: { background: "green", color: "#fff", padding: "10px" },
            });
            fetchPropertiesData();
          } catch (err) {
            showToast({
              message: err?.response?.data?.error?.message || "Failed to claim ad",
              customStyle: { background: "#ff4d4f", color: "#fff", padding: "10px" },
            });
          }
        })();
        return;
      }
      if (type === "Update Listing Score") {
        setModalConfig({
          title: "Update Listing score",
          desc: ``,
          withListingScore: true,
          initialData: {
            listingScore: listingScore,
          },
          showPostInput: false,
          onModalSubmit: (data) => {
            setIsModalOpen(false);
            handleUpdatePropertyStatus({
              updatedPropertyType,
              type: currentData.collection_type,
              slug: currentData.slug_url,
              id: currentData._id,
              custom_listing_score: data?.listingScore,
            });
          },
        });
      } else if (type === "Share To Social Media") {
        setModalConfig({
          title: "Share To Social Media",
          desc: "Are you sure you want to share this property to social media?",
          withListingScore: false,
          withShareToSocialMedia: false,
          showPostInput: true,
          initialData: {
            listingScore: listingScore,
            message: postMessage,
          },
          onModalSubmit: (data) => {
            setIsModalOpen(false);
            handleUpdatePropertyStatus({
              updatedPropertyType: type,
              slug: currentData.slug_url,
              message: data.message,
            });
          },
        });
      } else {
        setModalConfig({
          title: "Update property status",
          desc: `Are you sure you want to update status to <span style="font-weight: bold;">${type}</span>`,
          withListingScore: type === "Active" ? true : false,
          withShareToSocialMedia: type === "Active" ? true : false,
          showPostInput: type === "Active" ? true : false,
          initialData: {
            listingScore: listingScore,
            shareToSocialMedia: type === "Active" ? true : false,
            message: postMessage,
          },
          onModalSubmit: (data) => {
            setIsModalOpen(false);
            const { listingScore, message, shareToSocialMedia } = data || {};
            handleUpdatePropertyStatus({
              updatedPropertyType,
              type: currentData.collection_type,
              slug: currentData.slug_url,
              id: currentData._id,
              custom_listing_score: listingScore,
              shareToSocialMedia,
              message,
            });
          },
        });
      }
      setIsModalOpen(true);
    },
    [propertiesData]
  );

  const currentPropertyData = useMemo(
    () => propertiesData?.find((item) => item?._id === selectedAction?._id),
    [selectedAction, propertiesData]
  );

  if (error) {
    return <ErrorDisplay error={error} />;
  }

  return (
    <>
      <Box
        height="100vh"
        bg="#F8FAFB"
        // pt={{ base: "40px", md: "20px", xl: "20px" }}
      >
        <Flex
          justify="space-between"
          p={{ base: 2, md: 4 }}
          align="center"
          direction={{ base: "column", md: "row" }}
          boxShadow="sm"
          borderRadius="sm"
          pos={{ base: "relative", md: "fixed" }}
          w={{ base: "100%", md: "calc(100vw - 96px)" }}
          zIndex={1000}
          gap={{ base: 3, md: 4 }}
        >
          <Flex
            gap={{ base: 2, md: 4 }}
            w={{ base: "full", md: "auto" }}
            direction={{ base: "column", md: "row" }}
            p={{ base: 1, md: 2 }}
          >
            <Flex
              gap={{ base: 2, md: 4 }}
              align="center"
              justify={{ base: "end", md: "space-between" }}
              w={{ base: "full", md: "auto" }}
              wrap="wrap"
            >
              <Box position="relative">
                <Button
                  paddingX={6}
                  leftIcon={<FiFilter />}
                  rightIcon={<FiChevronsDown />} // Changed the icon to ChevronDown
                  colorScheme="teal"
                  variant="outline"
                  borderRadius="md"
                  size="sm"
                  onClick={() => {
                    toggleSidebar();
                    setFilters(lsFilters);
                  }}
                >
                  Filter
                </Button>
                {filteredData.length > 0 && (
                  <Badge
                    position="absolute"
                    top="-3"
                    right="0"
                    colorScheme="teal"
                    borderRadius="full"
                    px={2}
                    fontSize="0.8em"
                  >
                    {filteredData.length}
                  </Badge>
                )}
              </Box>
              <ManageColumns
                columns={columns}
                handleColumnChange={handleColumnChange}
                columnVisibility={columnVisibility}
                setManageColumnSelectAllCheckbox={
                  setManageColumnSelectAllCheckbox
                }
                manageColumnSelectḀ̥̥̥̥̥̥̥̥llCheckbox={manageColumnSelectḀ̥̥̥̥̥̥̥̥llCheckbox}
              />
            </Flex>
            <form onSubmit={handleInputFormSubmit}>
              <InputGroup size="sm">
                <SearchBar
                  background="#F9F9FB"
                  color="#637381"
                  setSearchText={(e) => setSearchText(e.target.value)}
                  searchText={searchText}
                  borderRadius="5px"
                  borderWidth="0.5px"
                  borderColor="#637381"
                />
              </InputGroup>
            </form>
          </Flex>
          <Flex
            gap={{ base: 4, md: 8 }}
            align="center"
            w={{ base: "full", md: "auto" }}
            justify={{ base: "space-between", md: "flex-start" }}
          >
            <Text
              fontSize="sm"
              borderRadius="5px"
              borderWidth="0.5px"
              borderColor="#637381"
              background="#F9F9FB"
              color="#637381"
              p={1}
              whiteSpace="nowrap"
            >
              Total Ads: {totalCount}
            </Text>
            <Button
              borderRadius="5px"
              borderColor="#637381"
              background={"linear-gradient(180deg, #22ACEE 0%, #0177B4 100%)"}
              color="#ffffff"
              fontSize="sm"
              colorScheme="teal"
              onClick={() => {
                history.push("/admin/form");
              }}
            >
              Create Ads
            </Button>
            <Button
              borderRadius="5px"
              borderColor="#637381"
              background={"linear-gradient(180deg, #22ACEE 0%, #0177B4 100%)"}
              color="#ffffff"
              fontSize="sm"
              colorScheme="teal"
              onClick={() => {
                setAllOpenExpiryUpdateModal(true);
              }}
            >
              Update Expiry
            </Button>
          </Flex>
          {/* Pagination */}
          <Flex justify="center" mt={{ base: 2, md: 0 }}>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(value) => {
                setSelectedRowsData([]);
                setCurrentPage(value);
              }}
              totalCount={totalCount}
              setCurrentPage={setCurrentPage}
              setPageSize={setPageSize}
              pageSize={pageSize}
              setPageSizeToLocalStorage={(value) =>
                setFilterToLocalStorage(
                  ENTITY_FILTER_TYPES.ADS_PAGE_SIZE,
                  value
                )
              }
            />
          </Flex>
        </Flex>

        <SidebarFilter
          filters={allFiltersProps}
          handleFilterChange={handleFilterChange}
          handleApplyFilter={handleApplyFilter}
          isOpen={isOpenFilterSidebar}
          onClose={toggleSidebar}
          appliedFilters={filters}
          setFilters={setFilters}
          lsFilters={lsFilters}
          handleRemoveAllFilter={handleRemoveAllFilter}
          // onFilterDateRangeSubmit={onFilterDateRangeSubmit}
          //date filter
          isCalenderFilter={true}
          startDate={filters?.startDate}
          setStartDate={setStartDate}
          endDate={filters?.endDate}
          setEndDate={setEndDate}
          ////location filter
          locationCitiesFilter={cityOptions}
          selectedCity={filters?.city}
          setSelectedCity={setSelectedCity}
        />
        {propertiesData.length !== 0 ? (
          <>
            <CustomTable
              columns={visibleColumns}
              data={data}
              conditionalStyling={(row) => {
                if (row?.original?.contact_view_limit_exhausted) {
                  return { backgroundColor: '#00ff002b' };
                }
                if (['admin', 'sales_admin'].includes(row?.original?.created_by_role)) {
                  return { backgroundColor: '#ff00002b' };
                }
                return {};
              }}
              onSelectedAction={setSelectedAction}
              selectedRowsData={selectedRowsData}
              selectedRowsSlug={selectedRowsSlug}
              selectedData={selectedData}
              handleRowSelect={handleRowSelect}
              setSelectedRowsData={setSelectedRowsData}
              //sorting props
              sortableColumns={sortableColumns}
              sortConfig={sortConfig}
              setSortConfig={setSortConfig}
              // single menu props
              menuComponent={
                <Menu
                  data={Object.values(PROPERTY_STATUS)}
                  onUpdate={() => {}}
                  onUpdatePropertyStatus={handleUpdatePropertyStatus}
                  selectedAction={selectedAction}
                  dataType="properties"
                  handleExternalModal={handleModalOpen}
                  showInput={true}
                />
              }
              // multi select menu props
              multiSelectMenuComponent={
                selectedRowsSlug?.length > 0 &&
                areAllStatusesSame(
                  selectedData.map((item) => item?.property_status)
                ) && (
                  <MultiSelectMenu
                    multiSelectCurrentValue={selectedData[0]?.property_status}
                    onMultipleUpdateStatus={handleMultipleUpdateStatus}
                    selectedAction={selectedAction}
                    selectedRowsData={selectedRowsData}
                    bgColor="#B2F5EA"
                    dataType="ads"
                  />
                )
              }
            />
          </>
        ) : !loading ? (
          <NoDataFound />
        ) : null}
        <OverlayLoaderComponent isOpen={loading} />
      </Box>
      <ExpiryUpdateModal
        isOpen={openExpiryUpdateModal}
        onClose={() => setOpenExpiryUpdateModal(false)}
        selectedRowsData={mappedRowsData}
      />
      <UpdateExpiryForAll
        isOpen={openALLExpiryUpdateModal}
        onClose={() => setAllOpenExpiryUpdateModal(false)}
      />
      <PropertiesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={modalConfig.title}
        desc={modalConfig.desc}
        withListingScore={modalConfig.withListingScore}
        withShareToSocialMedia={modalConfig.withShareToSocialMedia}
        withEmailCheckBox={false}
        propertyData={selctedProperty}
        onSubmit={modalConfig.onModalSubmit}
        showPostInput={modalConfig.showPostInput}
        initialData={modalConfig.initialData}
      />
      <RejectPropertyModal
        onClose={(updateList = false) => {
          setIsExpiryModalOpen(false);
          if (updateList) fetchPropertiesData();
        }}
        data={propertiesData.find((item) => item._id === selectedAction?._id)}
        isOpen={isExpiryModalOpen}
      />
      {isNearbyLeadsModalOpen && (
        <NearbyLeadsModal
          isOpen={isNearbyLeadsModalOpen}
          onClose={() => setIsNearbyLeadsModalOpen(false)}
          data={selctedProperty}
        />
      )}
      {isWhatsappModalOpen && (
        <ShareToWhatsapp
          isOpen={isWhatsappModalOpen}
          defaultMessageType={"expiry_notification"}
          onClose={() => setIsWhatsappModalOpen(false)}
          userData={currentPropertyData?.owner}
          slug={currentPropertyData?.slug_url}
          planUserType={
            currentPropertyData?.owner?.classified_primary_role ?? ""
          }
        />
      )}
    </>
  );
}
